import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-campaign-add-route',
  templateUrl: './campaign-add-route.component.html',
  styleUrls: ['./campaign-add-route.component.css']
})
export class CampaignAddRouteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
